import React from "react";
import {
  AreaChart,
  Area,
  BarChart,
  Bar,
  LineChart,
  Line,
  ComposedChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
  ReferenceLine,
  ReferenceArea,
  Legend,
} from "recharts";
import {
  RouteIcon,
  TrendingUp,
  Users,
  Activity,
  Crosshair,
  Sparkles,
  Trophy,
  ClipboardList,
  NotebookPen,
  Plus,
  Pencil,
  Trash2,
  ChevronDown,
  ChevronUp,
  Search,
  ArrowUpRight,
  ArrowDownRight,
  Download,
  Calendar,
  Clock,
  CheckCircle2,
  XCircle,
  AlertTriangle,
  Info,
  Zap,
  Brain,
  BarChart3,
  X,
  UserCheck,
  Building2,
  HeartHandshake,
  CalendarDays,
  CalendarCheck,
  Stethoscope,
  FlaskConical,
  Headphones,
  Receipt,
  Smartphone,
  Globe,
  HeartPulse,
  MessageSquare,
  ShoppingCart,
  CircleAlert,
  Lightbulb,
  TrendingDown,
  ScanSearch,
  Filter,
  Bell,
  Send,
  PanelLeftClose,
  PanelLeft,
  Archive,
  Link as LinkIcon,
  ExternalLink,
  History,
  Heart,
  MessageCircle,
  Share2,
  Upload,
  MapPin,
  ThumbsUp,
  ThumbsDown,
  EyeOff,
  Eye,
  Phone,
  Mail,
} from "lucide-react";
import * as S from "./_shared";
export default function SegmentationView({ ctx }) {
  const {
    ACOES_INIT,
    AcaoCard,
    AcaoDetalhe,
    AcaoModal,
    C,
    CES_COLS,
    CES_ETAPAS_NAMES,
    CES_TREND,
    CIDADES_COBERTURA,
    COOP_PLANOS_MOCK,
    CSAT_COLS,
    CSAT_ETAPAS_NAMES,
    CSAT_TREND,
    Card,
    DRIVERS_CANONICOS,
    DRIVER_TO_PILLAR,
    DistBar,
    ESCALA,
    ETAPA_DRIVER_AFFINITY,
    ETAPA_HIST,
    EtCard,
    EvaChat,
    EvaChatHistory,
    EvaInsights,
    F,
    HIST_ACOES_POR_ETAPA,
    JCFG,
    JICONS,
    LOGO,
    MESES_HIST,
    META_NPS,
    MUDANCAS_DESDE_ULTIMA_VISITA,
    MiniSparkline,
    NPSAnchor,
    PC,
    PDFExportModal,
    PER,
    PER_DEFAULT_LABELS,
    PER_OPTIONS,
    PILLAR_COLORS,
    PeriodPill,
    PeriodPillBig,
    SC,
    SHORT,
    SUCESSO_BADGES,
    SUCESSO_LEVELS,
    SYS_NPS,
    Section,
    TREND_BY_AGRUP,
    TT,
    Tag,
    ULTIMA_VISITA,
    UNIMED,
    VERBATINS_POR_ETAPA,
    Z_CX,
    Zonas,
    _META_CES_TR,
    _META_CSAT_TR,
    _META_NPS_TR,
    _SYS_CES_TR,
    _SYS_CSAT_TR,
    _SYS_NPS_TR,
    diasRest,
    etSt,
    exportPDF,
    fmtDt,
    getDriverInfo,
    getDriversForEtapa,
    getPilarOf,
    getSucessoStats,
    moe,
    pctChk,
    safeGanhoPp,
    tempoRelativo,
    todayStr,
  } = S;
  const {
    DATA,
    SAUDACAO_EVA,
    acaoSel,
    acoes,
    adicionarComentario,
    agrupT,
    atualizarMensagensChatEva,
    bulkApplyEtapas,
    bulkApplyGerais,
    bulkOpen,
    bulkPct,
    busca,
    cidadesAtivas,
    compartilharPlano,
    concluirWizard,
    coopBusca,
    coopComentariosAbertos,
    coopCurtidas,
    coopDriverFilter,
    coopEtapaFilter,
    coopNovoComentario,
    coopPlanos,
    d,
    db,
    dd,
    de,
    delAcao,
    desocultarNotif,
    dj,
    driverSortMode,
    ds,
    editandoMeta,
    editandoMetaEt,
    etapaDriversFilter,
    etapaHistSel,
    etapaSel,
    evaChatAtivoId,
    evaChats,
    excluirChatEva,
    filtroCidadeAberto,
    filtroResp,
    filtroSt,
    gamificacaoOn,
    hiddenLines,
    historicoEvaVisivel,
    jorGraf,
    marcarComoLida,
    marcarTodasLidas,
    metas,
    metasCardOpen,
    metasEtapas,
    modal,
    mostrarOcultos,
    naoLidas,
    nenhumaCidade,
    notifModalFiltro,
    notifModalOpen,
    notifOpen,
    notifs,
    notifsOcultas,
    notifsVisiveis,
    novoChatEva,
    ocultarNotif,
    openPublishWizard,
    pB,
    pD,
    pE,
    pJ,
    pS,
    per,
    periodoCustom,
    periodoG,
    respDropOpen,
    segHistMode,
    segIndicador,
    selecionarChatEva,
    setAcaoSel,
    setAcoes,
    setAgrupT,
    setBulkApplyEtapas,
    setBulkApplyGerais,
    setBulkOpen,
    setBulkPct,
    setBusca,
    setCidadesAtivas,
    setConcluirWizard,
    setCoopBusca,
    setCoopComentariosAbertos,
    setCoopCurtidas,
    setCoopDriverFilter,
    setCoopEtapaFilter,
    setCoopNovoComentario,
    setCoopPlanos,
    setDriverSortMode,
    setEditandoMeta,
    setEditandoMetaEt,
    setEtapaDriversFilter,
    setEtapaHistSel,
    setEtapaSel,
    setEvaChatAtivoId,
    setEvaChats,
    setFiltroCidadeAberto,
    setFiltroResp,
    setFiltroSt,
    setGamificacaoOn,
    setHiddenLines,
    setHistoricoEvaVisivel,
    setMetaEtapa,
    setMetas,
    setMetasCardOpen,
    setMetasEtapas,
    setModal,
    setMostrarOcultos,
    setNotifFeedback,
    setNotifModalFiltro,
    setNotifModalOpen,
    setNotifOpen,
    setNotifs,
    setPB,
    setPD,
    setPE,
    setPJ,
    setPS,
    setPeriodoCustom,
    setPeriodoG,
    setPrefilledAcao,
    setRespDropOpen,
    setSegIndicador,
    setStDropOpen,
    setSucessoFiltroPeriodo,
    setSucessoModalOpen,
    setTab,
    setTipoBenefAberto,
    setTipoBeneficiario,
    setVerbatinsModal,
    stDropOpen,
    sucessoFiltroPeriodo,
    sucessoModalOpen,
    tab,
    tipoBenefAberto,
    tipoBeneficiario,
    todasCidades,
    toggleCidade,
    toggleComentarios,
    toggleCoopDriver,
    toggleCurtida,
    toggleLine,
    toggleSegHist,
  } = ctx;
  return (() => {
    // KPIs consolidados
    const ces = Math.round(
      ds.etapas
        .filter((e) => (JCFG[e.e] && JCFG[e.e].tipo) === "ces")
        .reduce((s, e) => s + e.v, 0) /
        ds.etapas.filter((e) => (JCFG[e.e] && JCFG[e.e].tipo) === "ces").length,
    );
    const csat = Math.round(
      ds.etapas
        .filter((e) => (JCFG[e.e] && JCFG[e.e].tipo) === "csat")
        .reduce((s, e) => s + e.v, 0) /
        ds.etapas.filter((e) => (JCFG[e.e] && JCFG[e.e].tipo) === "csat")
          .length,
    );
    const jcx = Math.round(
      ds.etapas.reduce((s, e) => s + e.v, 0) / ds.etapas.length,
    );

    // Mock data — NPS por cidade (área de cobertura Unimed)
    const cidadesData = [
      { nome: "Vinhedo", nps: 71, csat: 87, ces: 75, delta: +1, n: 118 },
      { nome: "Valinhos", nps: 68, csat: 85, ces: 73, delta: +4, n: 142 },
      { nome: "Paulínia", nps: 66, csat: 84, ces: 72, delta: +3, n: 98 },
      { nome: "Jaguariúna", nps: 64, csat: 82, ces: 70, delta: +2, n: 89 },
      { nome: "Campinas", nps: 62, csat: 83, ces: 71, delta: +2, n: 847 },
      { nome: "Itatiba", nps: 59, csat: 80, ces: 69, delta: 0, n: 112 },
      { nome: "Hortolândia", nps: 57, csat: 81, ces: 68, delta: -1, n: 156 },
      { nome: "Sumaré", nps: 54, csat: 79, ces: 66, delta: -3, n: 203 },
    ];
    const corCidade = (nps) =>
      nps >= 75 ? C.green : nps >= 51 ? C.g700 : nps >= 25 ? "#F59E0B" : C.red;

    // Section divider
    const Divider = ({ label, color, sub }) => (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          marginTop: 8,
          marginBottom: -2,
        }}
      >
        <div
          style={{ width: 4, height: 18, borderRadius: 2, background: color }}
        />
        <div>
          <div
            style={{
              fontSize: 12,
              fontWeight: 700,
              color,
              letterSpacing: "-0.01em",
            }}
          >
            {label}
          </div>
          {sub && <div style={{ fontSize: 10, color: C.text4 }}>{sub}</div>}
        </div>
      </div>
    );

    // Reusable section renderer for NPS, CSAT and CES
    function SegSection({
      label,
      color,
      segData,
      gerData,
      origemData,
      meta,
      domain,
      valueSuffix,
      showZonas,
      cidadesData,
      cidadeKey,
    }) {
      const LINES = [
        {
          key: "geral",
          name: `${label} Geral`,
          stroke: color,
          width: 2.5,
          dash: "",
          grupo: "geral",
        },
        {
          key: "eGeral",
          name: "Empresa Geral",
          stroke: "#6D28D9",
          width: 2,
          dash: "",
          grupo: "tipo",
        },
        {
          key: "iGeral",
          name: "Individual Geral",
          stroke: "#DB2777",
          width: 2,
          dash: "",
          grupo: "tipo",
        },
        {
          key: "e5p",
          name: "Empresa >5a",
          stroke: "#A78BFA",
          width: 1.5,
          dash: "4 2",
          grupo: "tempo",
        },
        {
          key: "e5m",
          name: "Empresa <5a",
          stroke: "#F472B6",
          width: 1.5,
          dash: "4 2",
          grupo: "tempo",
        },
        {
          key: "i5p",
          name: "Individual >5a",
          stroke: "#06B6D4",
          width: 1.5,
          dash: "4 2",
          grupo: "tempo",
        },
        {
          key: "i5m",
          name: "Individual <5a",
          stroke: "#EAB308",
          width: 1.5,
          dash: "4 2",
          grupo: "tempo",
        },
        {
          key: "tit",
          name: "Titular",
          stroke: "#2563EB",
          width: 2,
          dash: "",
          grupo: "papel",
        },
        {
          key: "dep",
          name: "Dependente",
          stroke: "#EA580C",
          width: 2,
          dash: "",
          grupo: "papel",
        },
        {
          key: "apo",
          name: "Aposentado",
          stroke: "#92400E",
          width: 1.5,
          dash: "4 2",
          grupo: "papel",
        },
        // Gerações — adicionadas como linhas pontilhadas com cores próprias
        {
          key: "genZ",
          name: "Gen Z",
          stroke: "#10B981",
          width: 1.5,
          dash: "2 3",
          grupo: "geracao",
        },
        {
          key: "millennial",
          name: "Millennial",
          stroke: "#3B82F6",
          width: 1.5,
          dash: "2 3",
          grupo: "geracao",
        },
        {
          key: "genX",
          name: "Gen X",
          stroke: "#8B5CF6",
          width: 1.5,
          dash: "2 3",
          grupo: "geracao",
        },
        {
          key: "boomer",
          name: "Boomer",
          stroke: "#F97316",
          width: 1.5,
          dash: "2 3",
          grupo: "geracao",
        },
      ];

      // Enriquecer segData com valores por geração — derivados de gerData
      // com pequena variação determinística por mês pra criar a série temporal
      const segDataEnriched = segData.map((row, mIdx) => {
        const enriched = { ...row };
        const monthOffset = mIdx - (segData.length - 1);
        (gerData || []).forEach((g) => {
          const baseValor = g.n || 0;
          // Hash determinístico do nome da geração + label + período
          let h = 0;
          const seed = (g.g || "") + label + row.p;
          for (let k = 0; k < seed.length; k++)
            h = (h * 31 + seed.charCodeAt(k)) >>> 0;
          const drift = ((h % 7) - 3) * 0.6 + monthOffset * 0.4;
          const valor = Math.max(
            0,
            Math.min(100, Math.round(baseValor + drift)),
          );
          // Mapeia o nome da geração pra chave de coluna do chart
          if (g.g === "Gen Z") enriched.genZ = valor;
          else if (g.g === "Millennial") enriched.millennial = valor;
          else if (g.g === "Gen X") enriched.genX = valor;
          else if (g.g === "Baby Boomer" || g.g === "Boomer")
            enriched.boomer = valor;
        });
        return enriched;
      });

      // Cor dinâmica baseada no valor do indicador
      const corPorValor = (v) => {
        if (label === "NPS")
          return v >= 75
            ? C.green
            : v >= 50
              ? C.g700
              : v >= 0
                ? "#F59E0B"
                : C.red;
        return v >= 80
          ? C.green
          : v >= 65
            ? C.g700
            : v >= 50
              ? "#F59E0B"
              : C.red;
      };
      // Botão de toggle Consolidado <-> Série
      const ToggleSerie = ({ chartId }) => {
        const isHist = !!segHistMode[chartId];
        return (
          <button
            onClick={() => toggleSegHist(chartId)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 5,
              padding: "4px 10px",
              borderRadius: 14,
              border: `1px solid ${isHist ? color : C.border}`,
              background: isHist ? `${color}15` : "transparent",
              color: isHist ? color : C.text3,
              fontSize: 10,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "inherit",
              transition: "all .15s",
            }}
            title={
              isHist
                ? "Mostrando série histórica — clique para ver consolidado"
                : "Mostrando consolidado — clique para ver série histórica"
            }
          >
            <History size={11} />
            {isHist ? "Série histórica" : "Consolidado"}
          </button>
        );
      };
      // Histórico mock determinístico pra cidades/geração/origem
      const meses = segData.map((s) => s.p);
      const gerarHistorico = (itens, valorKey, labelKey) => {
        return meses.map((p, mIdx) => {
          const monthOffset = mIdx - (meses.length - 1);
          const row = { p };
          itens.forEach((it) => {
            const valor = it[valorKey] || 0;
            let h = 0;
            const seed = it[labelKey] || "";
            for (let k = 0; k < seed.length; k++)
              h = (h * 31 + seed.charCodeAt(k)) >>> 0;
            const drift = ((h % 6) - 2) * 0.7;
            row[seed] = Math.max(
              0,
              Math.min(100, Math.round(valor + monthOffset * drift)),
            );
          });
          return row;
        });
      };
      // Custom GenTick scoped to this section's data
      const GenTick = ({ x, y, payload }) => {
        const gen = gerData.find((g) => g.g === payload.value);
        return (
          <g transform={`translate(${x},${y})`}>
            <text
              x={0}
              y={0}
              dy={12}
              textAnchor="middle"
              fill={C.text2}
              fontSize={10}
              fontWeight={600}
            >
              {payload.value}
            </text>
            <text
              x={0}
              y={0}
              dy={25}
              textAnchor="middle"
              fill={C.text4}
              fontSize={9}
            >
              {gen ? `(${gen.range})` : ""}
            </text>
          </g>
        );
      };

      // Ações de marcar/desmarcar todas — opera em hiddenLines pra todas as keys do LINES
      const marcarTodas = () => {
        setHiddenLines((prev) => {
          const novo = { ...prev };
          LINES.forEach((l) => {
            delete novo[l.key];
          });
          return novo;
        });
      };
      const desmarcarTodas = () => {
        setHiddenLines((prev) => {
          const novo = { ...prev };
          LINES.forEach((l) => {
            novo[l.key] = true;
          });
          return novo;
        });
      };
      const todasMarcadas = LINES.every((l) => !hiddenLines[l.key]);
      const todasDesmarcadas = LINES.every((l) => hiddenLines[l.key]);

      return (
        <>
          <Divider
            label={`${label} — Segmentações`}
            color={color}
            sub={`Como o ${label} varia por tipo de beneficiário, geração e origem`}
          />

          {/* Multi-line chart */}
          <Section
            title={`${label} por segmento — clique na legenda para ocultar/exibir`}
            pad={false}
          >
            <div style={{ padding: "0 20px 18px" }}>
              {/* Botões de marcar/desmarcar todas */}
              <div
                style={{
                  display: "flex",
                  gap: 6,
                  marginBottom: 8,
                  paddingTop: 8,
                  alignItems: "center",
                }}
              >
                <button
                  onClick={marcarTodas}
                  disabled={todasMarcadas}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    padding: "4px 10px",
                    borderRadius: 14,
                    border: `1px solid ${todasMarcadas ? C.border : color}`,
                    background: todasMarcadas ? C.surf3 : `${color}15`,
                    color: todasMarcadas ? C.text4 : color,
                    fontSize: 10,
                    fontWeight: 600,
                    cursor: todasMarcadas ? "not-allowed" : "pointer",
                    fontFamily: "inherit",
                    transition: "all .15s",
                  }}
                >
                  <CheckCircle2 size={11} /> Marcar todas
                </button>
                <button
                  onClick={desmarcarTodas}
                  disabled={todasDesmarcadas}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    padding: "4px 10px",
                    borderRadius: 14,
                    border: `1px solid ${todasDesmarcadas ? C.border : C.text3}`,
                    background: "transparent",
                    color: todasDesmarcadas ? C.text4 : C.text3,
                    fontSize: 10,
                    fontWeight: 600,
                    cursor: todasDesmarcadas ? "not-allowed" : "pointer",
                    fontFamily: "inherit",
                    transition: "all .15s",
                  }}
                >
                  <EyeOff size={11} /> Desmarcar todas
                </button>
                <div
                  style={{
                    flex: 1,
                    height: 1,
                    background: C.border,
                    marginLeft: 6,
                  }}
                />
                <span
                  style={{ fontSize: 9, color: C.text4, fontStyle: "italic" }}
                >
                  {LINES.filter((l) => !hiddenLines[l.key]).length} de{" "}
                  {LINES.length} segmentos visíveis
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 6,
                  marginBottom: 10,
                }}
              >
                {LINES.map((l) => (
                  <button
                    key={l.key}
                    onClick={() => toggleLine(l.key)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      background: hiddenLines[l.key] ? C.surf3 : "transparent",
                      border: `1px solid ${hiddenLines[l.key] ? C.border : l.stroke}`,
                      borderRadius: 20,
                      padding: "3px 10px",
                      cursor: "pointer",
                      opacity: hiddenLines[l.key] ? 0.35 : 1,
                      transition: "all .2s",
                    }}
                  >
                    <div
                      style={{
                        width: 16,
                        height: 2,
                        borderRadius: 2,
                        background: l.stroke,
                        backgroundImage: l.dash
                          ? `repeating-linear-gradient(to right,${l.stroke} 0,${l.stroke} 4px,transparent 4px,transparent 6px)`
                          : "none",
                        backgroundColor: l.dash ? "transparent" : l.stroke,
                      }}
                    />
                    <span
                      style={{
                        fontSize: 10,
                        color: hiddenLines[l.key] ? C.text4 : C.text,
                        fontWeight: 500,
                      }}
                    >
                      {l.name}
                    </span>
                  </button>
                ))}
              </div>
              <ResponsiveContainer width="100%" height={340}>
                <LineChart
                  data={segDataEnriched}
                  margin={{ top: 4, right: 24 }}
                >
                  {showZonas && <Zonas tipo="nps" />}
                  <CartesianGrid
                    strokeDasharray="3 3"
                    stroke={C.border}
                    vertical={false}
                  />
                  <XAxis dataKey="p" tick={{ fontSize: 11, fill: C.text2 }} />
                  <YAxis
                    domain={domain}
                    tick={{ fontSize: 10, fill: C.text4 }}
                    tickFormatter={(v) => v + (valueSuffix || "")}
                  />
                  <Tooltip content={<TT />} />
                  <ReferenceLine
                    y={meta}
                    stroke={C.p400}
                    strokeDasharray="5 3"
                    label={{
                      value: `Meta ${meta}${valueSuffix || ""}`,
                      position: "right",
                      fontSize: 10,
                      fill: C.p600,
                    }}
                  />
                  {LINES.map((l) => (
                    <Line
                      key={l.key}
                      type="monotone"
                      dataKey={l.key}
                      name={l.name}
                      hide={!!hiddenLines[l.key]}
                      stroke={l.stroke}
                      strokeWidth={l.width}
                      strokeDasharray={l.dash || undefined}
                      dot={{
                        fill: l.stroke,
                        r: hiddenLines[l.key] ? 0 : 3,
                        strokeWidth: 0,
                      }}
                    />
                  ))}
                </LineChart>
              </ResponsiveContainer>
            </div>
          </Section>

          {/* Titular vs Dependente + Individual vs Empresa */}
          <div
            style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}
          >
            <Section title={`${label} — Titular vs Dependente`}>
              <div style={{ display: "flex", gap: 10, marginBottom: 12 }}>
                {[
                  { l: "Titular", k: "tit", c: "#2563EB" },
                  { l: "Dependente", k: "dep", c: "#EA580C" },
                ].map((s) => {
                  const last =
                    (segData[segData.length - 1]
                      ? segData[segData.length - 1][s.k]
                      : 0) || 0;
                  const first = (segData[0] ? segData[0][s.k] : 0) || 0;
                  const st =
                    ESCALA.find((e) => last >= e.min) ||
                    ESCALA[ESCALA.length - 1];
                  return (
                    <div
                      key={s.l}
                      style={{
                        flex: 1,
                        background: st.bg,
                        borderRadius: 12,
                        padding: "12px 14px",
                        border: `1px solid ${st.color}25`,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 10,
                          color: C.text4,
                          fontWeight: 600,
                          marginBottom: 3,
                        }}
                      >
                        {s.l}
                      </div>
                      <div
                        style={{
                          fontSize: 30,
                          fontWeight: 700,
                          color: st.color,
                          letterSpacing: "-0.04em",
                        }}
                      >
                        {last}
                        {valueSuffix || ""}
                      </div>
                      <div
                        style={{
                          fontSize: 10,
                          color: last - first >= 0 ? C.green : C.red,
                          fontWeight: 600,
                        }}
                      >
                        {last - first >= 0 ? "+" : ""}
                        {last - first}pts
                      </div>
                      <Tag label={st.label} color={st.color} bg={st.bg} />
                    </div>
                  );
                })}
              </div>
              <ResponsiveContainer width="100%" height={140}>
                <LineChart data={segData} margin={{ top: 4, right: 16 }}>
                  <CartesianGrid
                    strokeDasharray="3 3"
                    stroke={C.border}
                    vertical={false}
                  />
                  <XAxis dataKey="p" tick={{ fontSize: 10, fill: C.text2 }} />
                  <YAxis
                    domain={domain}
                    tick={{ fontSize: 9, fill: C.text4 }}
                    tickFormatter={(v) => v + (valueSuffix || "")}
                  />
                  <Tooltip content={<TT />} />
                  <ReferenceLine
                    y={meta}
                    stroke={C.p400}
                    strokeDasharray="4 2"
                  />
                  <Line
                    type="monotone"
                    dataKey="tit"
                    name="Titular"
                    stroke="#2563EB"
                    strokeWidth={2}
                    dot={{ fill: "#2563EB", r: 3, strokeWidth: 0 }}
                  />
                  <Line
                    type="monotone"
                    dataKey="dep"
                    name="Dependente"
                    stroke="#EA580C"
                    strokeWidth={2}
                    dot={{ fill: "#EA580C", r: 3, strokeWidth: 0 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </Section>
            <Section title={`${label} — Individual Geral vs Empresa Geral`}>
              <div style={{ display: "flex", gap: 10, marginBottom: 12 }}>
                {[
                  { l: "Individual Geral", k: "iGeral", c: "#DB2777" },
                  { l: "Empresa Geral", k: "eGeral", c: "#6D28D9" },
                ].map((s) => {
                  const last =
                    (segData[segData.length - 1]
                      ? segData[segData.length - 1][s.k]
                      : 0) || 0;
                  const first = (segData[0] ? segData[0][s.k] : 0) || 0;
                  const st =
                    ESCALA.find((e) => last >= e.min) ||
                    ESCALA[ESCALA.length - 1];
                  return (
                    <div
                      key={s.l}
                      style={{
                        flex: 1,
                        background: st.bg,
                        borderRadius: 12,
                        padding: "12px 14px",
                        border: `1px solid ${st.color}25`,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 10,
                          color: C.text4,
                          fontWeight: 600,
                          marginBottom: 3,
                        }}
                      >
                        {s.l}
                      </div>
                      <div
                        style={{
                          fontSize: 30,
                          fontWeight: 700,
                          color: st.color,
                          letterSpacing: "-0.04em",
                        }}
                      >
                        {last}
                        {valueSuffix || ""}
                      </div>
                      <div
                        style={{
                          fontSize: 10,
                          color: last - first >= 0 ? C.green : C.red,
                          fontWeight: 600,
                        }}
                      >
                        {last - first >= 0 ? "+" : ""}
                        {last - first}pts
                      </div>
                      <Tag label={st.label} color={st.color} bg={st.bg} />
                    </div>
                  );
                })}
              </div>
              <ResponsiveContainer width="100%" height={140}>
                <LineChart data={segData} margin={{ top: 4, right: 16 }}>
                  <CartesianGrid
                    strokeDasharray="3 3"
                    stroke={C.border}
                    vertical={false}
                  />
                  <XAxis dataKey="p" tick={{ fontSize: 10, fill: C.text2 }} />
                  <YAxis
                    domain={domain}
                    tick={{ fontSize: 9, fill: C.text4 }}
                    tickFormatter={(v) => v + (valueSuffix || "")}
                  />
                  <Tooltip content={<TT />} />
                  <ReferenceLine
                    y={meta}
                    stroke={C.p400}
                    strokeDasharray="4 2"
                  />
                  <Line
                    type="monotone"
                    dataKey="iGeral"
                    name="Individual Geral"
                    stroke="#DB2777"
                    strokeWidth={2}
                    dot={{ fill: "#DB2777", r: 3, strokeWidth: 0 }}
                  />
                  <Line
                    type="monotone"
                    dataKey="eGeral"
                    name="Empresa Geral"
                    stroke="#6D28D9"
                    strokeWidth={2}
                    dot={{ fill: "#6D28D9", r: 3, strokeWidth: 0 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </Section>
          </div>

          {/* Geração + Local vs Intercâmbio */}
          <div
            style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}
          >
            <Section
              title={`${label} por geração`}
              pad={false}
              action={<ToggleSerie chartId={`ger_${label}`} />}
            >
              <div style={{ padding: "16px 20px 0" }}>
                <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                  {gerData.map((g) => {
                    const st =
                      ESCALA.find((e) => g.n >= e.min) ||
                      ESCALA[ESCALA.length - 1];
                    return (
                      <div
                        key={g.g}
                        style={{
                          flex: 1,
                          background: st.bg,
                          borderRadius: 12,
                          padding: "10px 12px",
                          border: `1px solid ${st.color}25`,
                          minWidth: 0,
                        }}
                      >
                        <div
                          style={{
                            fontSize: 10,
                            color: C.text4,
                            fontWeight: 600,
                            marginBottom: 2,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {g.g}
                        </div>
                        <div
                          style={{
                            fontSize: 24,
                            fontWeight: 700,
                            color: st.color,
                            letterSpacing: "-0.04em",
                            lineHeight: 1,
                          }}
                        >
                          {g.n}
                          {valueSuffix || ""}
                        </div>
                        <div
                          style={{ fontSize: 9, color: C.text4, marginTop: 2 }}
                        >
                          {g.range}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div style={{ padding: "0 20px 16px" }}>
                {!segHistMode[`ger_${label}`] ? (
                  <ResponsiveContainer width="100%" height={180}>
                    <BarChart
                      data={gerData}
                      margin={{ top: 8, right: 16, bottom: 14 }}
                    >
                      {showZonas && <Zonas tipo="nps" />}
                      <CartesianGrid
                        strokeDasharray="3 3"
                        vertical={false}
                        stroke={C.border}
                      />
                      <XAxis
                        dataKey="g"
                        tick={GenTick}
                        interval={0}
                        height={42}
                      />
                      <YAxis
                        domain={domain}
                        tick={{ fontSize: 10, fill: C.text4 }}
                        tickFormatter={(v) => v + (valueSuffix || "")}
                      />
                      <Tooltip
                        content={({ active, payload, labelArg }) => {
                          if (!active || !(payload && payload.length))
                            return null;
                          const lbl =
                            payload[0] &&
                            payload[0].payload &&
                            payload[0].payload.g;
                          const g = gerData.find((x) => x.g === lbl);
                          return (
                            <div
                              style={{
                                background: "rgba(28,28,30,.95)",
                                borderRadius: 10,
                                padding: "8px 12px",
                                fontSize: 12,
                                border: "1px solid rgba(255,255,255,.1)",
                              }}
                            >
                              <div
                                style={{
                                  color: C.g300,
                                  fontWeight: 600,
                                  marginBottom: 3,
                                }}
                              >
                                {lbl}{" "}
                                <span
                                  style={{
                                    color: "rgba(255,255,255,.5)",
                                    fontWeight: 400,
                                  }}
                                >
                                  ({g && g.range})
                                </span>
                              </div>
                              <div style={{ color: "#FFFFFF" }}>
                                {label}:{" "}
                                <b>
                                  {g && g.n}
                                  {valueSuffix || ""}
                                </b>
                              </div>
                              <div
                                style={{
                                  color: "rgba(255,255,255,.5)",
                                  fontSize: 10,
                                }}
                              >
                                {g && g.resp.toLocaleString()} respondentes
                              </div>
                            </div>
                          );
                        }}
                      />
                      <ReferenceLine
                        y={meta}
                        stroke={C.p400}
                        strokeDasharray="5 3"
                      />
                      <Bar
                        dataKey="n"
                        name={label}
                        radius={[6, 6, 0, 0]}
                        maxBarSize={56}
                      >
                        {gerData.map((g, i) => (
                          <Cell
                            key={i}
                            fill={
                              (
                                ESCALA.find((e) => g.n >= e.min) ||
                                ESCALA[ESCALA.length - 1]
                              ).color
                            }
                          />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                ) : (
                  (() => {
                    const histGer = gerarHistorico(gerData, "n", "g");
                    const cores = [
                      "#7C3AED",
                      "#0284c7",
                      "#16a34a",
                      "#d97706",
                      "#dc2626",
                      "#0891b2",
                    ];
                    return (
                      <ResponsiveContainer width="100%" height={220}>
                        <LineChart
                          data={histGer}
                          margin={{ top: 8, right: 16, bottom: 0, left: 0 }}
                        >
                          <CartesianGrid
                            strokeDasharray="3 3"
                            stroke={C.border}
                            vertical={false}
                          />
                          <XAxis
                            dataKey="p"
                            tick={{ fontSize: 10, fill: C.text2 }}
                          />
                          <YAxis
                            domain={domain}
                            tick={{ fontSize: 10, fill: C.text4 }}
                            tickFormatter={(v) => v + (valueSuffix || "")}
                          />
                          <Tooltip content={<TT />} />
                          <Legend
                            wrapperStyle={{ fontSize: 10, paddingTop: 6 }}
                          />
                          <ReferenceLine
                            y={meta}
                            stroke={C.p400}
                            strokeDasharray="5 3"
                          />
                          {gerData.map((g, i) => (
                            <Line
                              key={g.g}
                              type="monotone"
                              dataKey={g.g}
                              name={g.g}
                              stroke={cores[i % cores.length]}
                              strokeWidth={2}
                              dot={{
                                fill: cores[i % cores.length],
                                r: 3,
                                strokeWidth: 0,
                              }}
                            />
                          ))}
                        </LineChart>
                      </ResponsiveContainer>
                    );
                  })()
                )}
              </div>
            </Section>
            <Section
              title={`${label} — Local vs Intercâmbio`}
              pad={false}
              action={<ToggleSerie chartId={`ori_${label}`} />}
            >
              <div style={{ padding: "16px 20px 0" }}>
                <div style={{ display: "flex", gap: 10, marginBottom: 12 }}>
                  {origemData.map((o) => {
                    const st =
                      ESCALA.find((e) => o.n >= e.min) ||
                      ESCALA[ESCALA.length - 1];
                    return (
                      <div
                        key={o.t}
                        style={{
                          flex: 1,
                          background: st.bg,
                          borderRadius: 12,
                          padding: "12px 14px",
                          border: `1px solid ${st.color}25`,
                        }}
                      >
                        <div
                          style={{
                            fontSize: 10,
                            color: C.text4,
                            fontWeight: 600,
                            marginBottom: 3,
                          }}
                        >
                          {o.t}
                        </div>
                        <div
                          style={{
                            fontSize: 30,
                            fontWeight: 700,
                            color: st.color,
                            letterSpacing: "-0.04em",
                          }}
                        >
                          {o.n}
                          {valueSuffix || ""}
                        </div>
                        <div
                          style={{ fontSize: 10, color: C.text4, marginTop: 2 }}
                        >
                          {o.resp.toLocaleString()} respondentes
                        </div>
                        <Tag label={st.label} color={st.color} bg={st.bg} />
                      </div>
                    );
                  })}
                </div>
              </div>
              <div style={{ padding: "0 20px 16px" }}>
                {!segHistMode[`ori_${label}`] ? (
                  <ResponsiveContainer width="100%" height={180}>
                    <BarChart
                      data={origemData}
                      margin={{ top: 8, right: 16, bottom: 14 }}
                    >
                      {showZonas && <Zonas tipo="nps" />}
                      <CartesianGrid
                        strokeDasharray="3 3"
                        vertical={false}
                        stroke={C.border}
                      />
                      <XAxis
                        dataKey="t"
                        tick={{ fontSize: 11, fill: C.text2, fontWeight: 600 }}
                        interval={0}
                        height={42}
                      />
                      <YAxis
                        domain={domain}
                        tick={{ fontSize: 10, fill: C.text4 }}
                        tickFormatter={(v) => v + (valueSuffix || "")}
                      />
                      <Tooltip
                        content={({ active, payload }) => {
                          if (!active || !(payload && payload.length))
                            return null;
                          const lbl =
                            payload[0] &&
                            payload[0].payload &&
                            payload[0].payload.t;
                          const o = origemData.find((x) => x.t === lbl);
                          return (
                            <div
                              style={{
                                background: "rgba(28,28,30,.95)",
                                borderRadius: 10,
                                padding: "8px 12px",
                                fontSize: 12,
                                border: "1px solid rgba(255,255,255,.1)",
                              }}
                            >
                              <div
                                style={{
                                  color: C.g300,
                                  fontWeight: 600,
                                  marginBottom: 3,
                                }}
                              >
                                {lbl}
                              </div>
                              <div style={{ color: "#FFFFFF" }}>
                                {label}:{" "}
                                <b>
                                  {o && o.n}
                                  {valueSuffix || ""}
                                </b>
                              </div>
                              <div
                                style={{
                                  color: "rgba(255,255,255,.5)",
                                  fontSize: 10,
                                }}
                              >
                                {o && o.resp.toLocaleString()} respondentes
                              </div>
                            </div>
                          );
                        }}
                      />
                      <ReferenceLine
                        y={meta}
                        stroke={C.p400}
                        strokeDasharray="5 3"
                      />
                      <Bar
                        dataKey="n"
                        name={label}
                        radius={[6, 6, 0, 0]}
                        maxBarSize={80}
                      >
                        {origemData.map((o, i) => (
                          <Cell
                            key={i}
                            fill={
                              (
                                ESCALA.find((e) => o.n >= e.min) ||
                                ESCALA[ESCALA.length - 1]
                              ).color
                            }
                          />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                ) : (
                  (() => {
                    const histOri = gerarHistorico(origemData, "n", "t");
                    const cores = ["#0284c7", "#dc2626", "#16a34a"];
                    return (
                      <ResponsiveContainer width="100%" height={220}>
                        <LineChart
                          data={histOri}
                          margin={{ top: 8, right: 16, bottom: 0, left: 0 }}
                        >
                          <CartesianGrid
                            strokeDasharray="3 3"
                            stroke={C.border}
                            vertical={false}
                          />
                          <XAxis
                            dataKey="p"
                            tick={{ fontSize: 10, fill: C.text2 }}
                          />
                          <YAxis
                            domain={domain}
                            tick={{ fontSize: 10, fill: C.text4 }}
                            tickFormatter={(v) => v + (valueSuffix || "")}
                          />
                          <Tooltip content={<TT />} />
                          <Legend
                            wrapperStyle={{ fontSize: 10, paddingTop: 6 }}
                          />
                          <ReferenceLine
                            y={meta}
                            stroke={C.p400}
                            strokeDasharray="5 3"
                          />
                          {origemData.map((o, i) => (
                            <Line
                              key={o.t}
                              type="monotone"
                              dataKey={o.t}
                              name={o.t}
                              stroke={cores[i % cores.length]}
                              strokeWidth={2}
                              dot={{
                                fill: cores[i % cores.length],
                                r: 3,
                                strokeWidth: 0,
                              }}
                            />
                          ))}
                        </LineChart>
                      </ResponsiveContainer>
                    );
                  })()
                )}
              </div>
            </Section>
          </div>

          {/* === POR CIDADE — agora dentro de cada SegSection === */}
          {cidadesData &&
            cidadesData.length > 0 &&
            (() => {
              const histCid = gerarHistorico(cidadesData, cidadeKey, "nome");
              const corCid = (v) => corPorValor(v);
              return (
                <Section
                  title={`${label} por cidade — área de cobertura ${UNIMED}`}
                  pad={false}
                  action={<ToggleSerie chartId={`cid_${label}`} />}
                >
                  <div style={{ padding: "8px 20px 18px" }}>
                    {!segHistMode[`cid_${label}`] ? (
                      <>
                        <ResponsiveContainer width="100%" height={300}>
                          <BarChart
                            data={cidadesData}
                            layout="vertical"
                            margin={{ top: 8, right: 40, left: 8, bottom: 0 }}
                          >
                            <CartesianGrid
                              strokeDasharray="3 3"
                              stroke={C.border}
                              horizontal={false}
                            />
                            <XAxis
                              type="number"
                              domain={[0, 100]}
                              tick={{ fontSize: 10, fill: C.text4 }}
                              tickFormatter={(v) => v + (valueSuffix || "")}
                            />
                            <YAxis
                              type="category"
                              dataKey="nome"
                              tick={{
                                fontSize: 11,
                                fill: C.text2,
                                fontWeight: 500,
                              }}
                              width={95}
                            />
                            <Tooltip content={<TT />} />
                            <ReferenceLine
                              x={meta}
                              stroke={C.p400}
                              strokeDasharray="5 3"
                              label={{
                                value: `Meta ${meta}${valueSuffix || ""}`,
                                position: "top",
                                fontSize: 10,
                                fill: C.p600,
                              }}
                            />
                            <Bar
                              dataKey={cidadeKey}
                              name={label}
                              radius={[0, 6, 6, 0]}
                              maxBarSize={22}
                            >
                              {cidadesData.map((c, i) => (
                                <Cell key={i} fill={corCid(c[cidadeKey])} />
                              ))}
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                        {/* Grid de cards detalhados por cidade */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns:
                              "repeat(auto-fit, minmax(165px, 1fr))",
                            gap: 10,
                            marginTop: 14,
                          }}
                        >
                          {cidadesData.map((c) => (
                            <Card key={c.nome} style={{ padding: "12px 14px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 5,
                                  marginBottom: 6,
                                }}
                              >
                                <MapPin size={11} color={C.text4} />
                                <div
                                  style={{
                                    fontSize: 11,
                                    fontWeight: 700,
                                    color: C.text,
                                    letterSpacing: "-0.01em",
                                    flex: 1,
                                    minWidth: 0,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {c.nome}
                                </div>
                                <div
                                  style={{
                                    fontSize: 9,
                                    color: C.text4,
                                    fontWeight: 500,
                                  }}
                                >
                                  n={c.n}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "baseline",
                                  gap: 6,
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: 22,
                                    fontWeight: 700,
                                    color: corCid(c[cidadeKey]),
                                    letterSpacing: "-0.03em",
                                    fontFamily: F.display,
                                  }}
                                >
                                  {c[cidadeKey]}
                                  {valueSuffix || ""}
                                </div>
                                <div
                                  style={{
                                    fontSize: 9,
                                    color: C.text4,
                                    fontWeight: 600,
                                  }}
                                >
                                  {label}
                                </div>
                              </div>
                            </Card>
                          ))}
                        </div>
                      </>
                    ) : (
                      (() => {
                        const cores = [
                          "#16a34a",
                          "#0284c7",
                          "#7C3AED",
                          "#d97706",
                          "#dc2626",
                          "#0891b2",
                          "#DB2777",
                          "#92400E",
                        ];
                        return (
                          <ResponsiveContainer width="100%" height={320}>
                            <LineChart
                              data={histCid}
                              margin={{ top: 8, right: 16, bottom: 0, left: 0 }}
                            >
                              <CartesianGrid
                                strokeDasharray="3 3"
                                stroke={C.border}
                                vertical={false}
                              />
                              <XAxis
                                dataKey="p"
                                tick={{ fontSize: 11, fill: C.text2 }}
                              />
                              <YAxis
                                domain={domain}
                                tick={{ fontSize: 10, fill: C.text4 }}
                                tickFormatter={(v) => v + (valueSuffix || "")}
                              />
                              <Tooltip content={<TT />} />
                              <Legend
                                wrapperStyle={{ fontSize: 10, paddingTop: 6 }}
                              />
                              <ReferenceLine
                                y={meta}
                                stroke={C.p400}
                                strokeDasharray="5 3"
                              />
                              {cidadesData.map((c, i) => (
                                <Line
                                  key={c.nome}
                                  type="monotone"
                                  dataKey={c.nome}
                                  name={c.nome}
                                  stroke={cores[i % cores.length]}
                                  strokeWidth={2}
                                  dot={{
                                    fill: cores[i % cores.length],
                                    r: 3,
                                    strokeWidth: 0,
                                  }}
                                />
                              ))}
                            </LineChart>
                          </ResponsiveContainer>
                        );
                      })()
                    )}
                  </div>
                </Section>
              );
            })()}
        </>
      );
    }

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div
              style={{
                fontSize: 15,
                fontWeight: 700,
                color: C.text,
                letterSpacing: "-0.02em",
              }}
            >
              Segmentação
            </div>
            <div style={{ fontSize: 11, color: C.text4, marginTop: 2 }}>
              Selecione um indicador acima para ver suas segmentações por tipo,
              geração, origem e cidade.
            </div>
          </div>
          <PeriodPill value={pS} onChange={setPS} />
        </div>

        {/* Seletor de indicador — 3 botões grandes */}
        <div
          style={{
            display: "flex",
            gap: 8,
            padding: "6px",
            background: C.surf3,
            borderRadius: 14,
            border: `1px solid ${C.border}`,
          }}
        >
          {[
            {
              key: "nps",
              label: "NPS",
              sub: "Lealdade",
              valor: ds.nps,
              color: C.g700,
            },
            {
              key: "csat",
              label: "CSAT",
              sub: "Satisfação",
              valor: csat + "%",
              color: C.g600,
            },
            {
              key: "ces",
              label: "CES",
              sub: "Esforço",
              valor: ces + "%",
              color: C.blue,
            },
          ].map((opt) => {
            const active = segIndicador === opt.key;
            return (
              <button
                key={opt.key}
                onClick={() => setSegIndicador(opt.key)}
                style={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  padding: "14px 18px",
                  borderRadius: 11,
                  background: active ? "#FFFFFF" : "transparent",
                  border: active
                    ? `1.5px solid ${opt.color}`
                    : `1.5px solid transparent`,
                  cursor: "pointer",
                  transition: "all .18s",
                  boxShadow: active
                    ? `0 4px 12px ${opt.color}20, 0 2px 4px rgba(0,0,0,.04)`
                    : "none",
                  fontFamily: "inherit",
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    width: 8,
                    height: 36,
                    borderRadius: 4,
                    background: active ? opt.color : C.border,
                    transition: "all .18s",
                  }}
                />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: active ? opt.color : C.text3,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      marginBottom: 3,
                    }}
                  >
                    {opt.label}
                  </div>
                  <div
                    style={{
                      fontSize: 9,
                      color: active ? C.text3 : C.text4,
                      fontWeight: 500,
                    }}
                  >
                    {opt.sub}
                  </div>
                </div>
                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 700,
                    color: active ? opt.color : C.text4,
                    fontFamily: F.display,
                    letterSpacing: "-0.03em",
                    transition: "all .18s",
                  }}
                >
                  {opt.valor}
                </div>
              </button>
            );
          })}
        </div>

        {/* === Indicador selecionado: render condicional === */}
        {segIndicador === "nps" && (
          <SegSection
            label="NPS"
            color={C.g700}
            segData={ds.segMensal}
            gerData={ds.geracoes}
            origemData={ds.origem}
            meta={metas.nps}
            domain={[20, 90]}
            valueSuffix=""
            showZonas={true}
            cidadesData={cidadesData}
            cidadeKey="nps"
          />
        )}

        {segIndicador === "csat" && (
          <SegSection
            label="CSAT"
            color={C.g600}
            segData={ds.segMensalCsat}
            gerData={ds.geracoesCsat}
            origemData={ds.origemCsat}
            meta={metas.csat}
            domain={[50, 95]}
            valueSuffix="%"
            showZonas={false}
            cidadesData={cidadesData}
            cidadeKey="csat"
          />
        )}

        {segIndicador === "ces" && (
          <SegSection
            label="CES"
            color={C.blue}
            segData={ds.segMensalCes}
            gerData={ds.geracoesCes}
            origemData={ds.origemCes}
            meta={metas.ces}
            domain={[20, 75]}
            valueSuffix="%"
            showZonas={false}
            cidadesData={cidadesData}
            cidadeKey="ces"
          />
        )}
      </div>
    );
  })();
}

{
  /* == ENGAJAMENTO == */
}
{
  /* == ENGAJAMENTO virou modal acessível pelo badge no header == */
}
